module.exports = __webpack_public_path__ + "img/_icon-zip-codes.743fdbbb.svg";